import { render, staticRenderFns } from "./StepVerifyQuestions.vue?vue&type=template&id=4df957c4&"
import script from "./StepVerifyQuestions.vue?vue&type=script&lang=js&"
export * from "./StepVerifyQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports